var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconClock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2 9a7 7 0 1 1 14 0A7 7 0 0 1 2 9Zm7-9a9 9 0 1 0 0 18A9 9 0 0 0 9 0Zm1 5a1 1 0 1 0-2 0v3.586A2 2 0 0 0 8.586 10l1.707 1.707a1 1 0 0 0 1.414-1.414L10 8.586V5Z",
  clipRule: "evenodd"
})));
export default SvgIconClock;